// Traducciones en Español
export const es = {
  common: {
    welcome: "Bienvenido",
    logout: "Cerrar Sesión",
    login: "Iniciar Sesión",
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    cancel: "Cancelar",
    save: "Guardar",
    delete: "Eliminar",
    edit: "Editar",
    back: "Volver",
    next: "Siguiente",
    previous: "Anterior",
    search: "Buscar",
    filter: "Filtrar",
    close: "Cerrar",
  },
  login: {
    title: "Iniciar Sesión",
    subtitle: "Accede a tu cuenta de Auriga",
    button: "Iniciar Sesión con Authentik",
    checking: "Verificando sesión...",
    redirecting: "Redirigiendo...",
    tryAnotherUser: "Puedes intentar iniciar sesión con otro usuario haciendo clic en el botón de abajo.",
    tryAgain: "Intentar con Otro Usuario",
  },
  dashboard: {
    title: "Dashboard",
    welcome: "Bienvenido",
    userInfo: "Información del Usuario",
    email: "Email",
    id: "ID",
    apiInfo: "Información de la API",
    noUserData: "No hay información de usuario disponible.",
    sections: "Secciones Disponibles",
    qualityDashboard: "Dashboard de Calidad",
    maintenanceDashboard: "Dashboard de Mantenimiento",
    adminDashboard: "Dashboard de Administración",
    noAccess: "No tienes acceso a secciones especializadas. Contacta al administrador para obtener permisos.",
    permissions: "Información de Permisos",
    factories: "Fábricas",
    roles: "Roles",
    departments: "Departamentos",
    groups: "Grupos",
    none: "Ninguno",
    noneFound: "Ninguna",
    categories: {
      general: "General",
      productive: "Gestión Productiva",
      people: "Gestión de Personas",
      quality: "Gestión de Calidad",
      processes: "Gestión de Procesos",
      assets: "Gestión de Activos",
      safety: "Seguridad y Salud",
      configuration: "Configuración",
      administration: "Administración",
      mobile: "Móvil",
    },
  },
  quality: {
    title: "Dashboard de Calidad",
    permissions: "Información de Permisos",
    accessChecks: "Verificaciones de Acceso",
    factoryAccess: "Acceso a",
    roleIn: "Rol",
    features: "Funcionalidades de Calidad",
    inspections: "Gestión de inspecciones",
    qualityControl: "Control de calidad",
    nonConformities: "Reportes de no conformidades",
    trends: "Análisis de tendencias",
  },
  maintenance: {
    title: "Dashboard de Mantenimiento",
    permissions: "Información de Permisos",
    accessChecks: "Verificaciones de Acceso",
    factoryAccess: "Acceso a",
    roleIn: "Rol",
    features: "Funcionalidades de Mantenimiento",
    planning: "Planificación de mantenimiento",
    workOrders: "Órdenes de trabajo",
    equipment: "Gestión de equipos",
    history: "Historial de mantenimientos",
  },
  admin: {
    title: "Dashboard de Administración",
    permissions: "Información de Permisos",
    accessChecks: "Verificaciones de Acceso",
    group: "Grupo",
    features: "Funcionalidades de Administración",
    users: "Gestión de usuarios",
    system: "Configuración del sistema",
    reports: "Reportes administrativos",
    audit: "Auditoría y logs",
  },
  errors: {
    notAuthenticated: "No autenticado",
    accessDenied: "Acceso Denegado",
    noPermission: "No tienes permisos para acceder a esta sección.",
    requirements: "Requisitos",
    factory: "Fábrica",
    department: "Departamento",
    role: "Rol",
    group: "Grupo",
    backToDashboard: "Volver al Dashboard",
    authenticationError: "Error de Autenticación",
    codeExpired: "El código de autorización ha expirado. Por favor, intenta iniciar sesión nuevamente.",
    accountDisabled: "Tu cuenta ha sido deshabilitada. Por favor, contacta a tu administrador.",
  },
  produccion: {
    ordenesFabricacion: { title: "Órdenes de Fabricación", description: "Gestión de órdenes de fabricación" },
    programacion: { title: "Programación", description: "Programación de producción" },
    oeeMetricas: { title: "Métricas OEE", description: "Métricas OEE (Overall Equipment Effectiveness)" },
    materialesConsumos: { title: "Materiales y Consumos", description: "Control de materiales y consumos" },
    lotesTrazabilidad: {
      title: "Lotes y Trazabilidad",
      description: "Trazabilidad de lotes",
      import: "Importar",
      batches: "Lotes",
      traceability: "Trazabilidad",
      salaMezcla: "Sala Mezcla",
      salaMezclaTitle: "Control Sala Mezcla",
      salaMezclaDesc: "Recepción de pallets (HU / SSCC) desde PDA",
      openPda: "Abrir PDA",
      copyPdaLink: "Copiar link PDA",
      huReceived: "HU recepcionada",
      huDuplicate: "HU ya recepcionada",
      registerHu: "Registrar HU",
      manualEntry: "Manual",
      scanHint: "Escanee el código del pallet o use ingreso manual",
    },
  },
  personas: {
    turnos: {
      title: "Turnos",
      description: "Gestión de turnos de trabajo",
      listTitle: "Listado de turnos",
      shiftOne: "turno",
      shiftsMany: "turnos",
      empty: "No hay turnos registrados.",
      loading: "Cargando turnos...",
      colName: "Nombre",
      colFactory: "Fábrica",
      colStartTime: "Hora inicio",
      colEndTime: "Hora fin",
      colDescription: "Descripción",
      colTolerance: "Tolerancia (min)",
      colStatus: "Estado",
      colUpdated: "Última actualización",
      statusActive: "Activo",
      statusInactive: "Inactivo",
      showing: "Mostrando",
      of: "de",
      pageLabel: "Página",
    },
    empleados: { title: "🙍‍♂️ Empleados", description: "Gestión de empleados" },
    horariosTrabajo: { title: "Horarios de Trabajo", description: "Horarios de trabajo diarios" },
    asistencia: { title: "Asistencia", description: "Control de asistencia" },
    asignaciones: { title: "Asignaciones", description: "Asignaciones de personal" },
    salidasEspeciales: { title: "Salidas Especiales", description: "Gestión de salidas especiales" },
    evaluaciones: { title: "Evaluaciones", description: "Evaluaciones de personal" },
  },
  calidad: {
    planesInspeccion: { title: "Planes de Inspección", description: "Planes de inspección y ensayos (ITP)" },
    autocontrolCalidad: { title: "Autocontrol de Calidad", description: "Autocontrol de calidad por plan" },
    registrosAutocontrol: { title: "Registros de Autocontrol", description: "Registros de autocontrol" },
    caracteristicasCalidad: { title: "Características de Calidad", description: "Características de calidad" },
    defectos: { title: "Defectos", description: "Gestión de defectos" },
    controlEstadistico: { title: "Control Estadístico", description: "Control estadístico de procesos" },
    accionesCorrectivas: { title: "Acciones Correctivas", description: "Acciones correctivas" },
    certificados: { title: "Certificados", description: "Gestión de certificados" },
  },
  procesos: {
    datosMaestros: { title: "Datos Maestros de Procesos", description: "Datos maestros de procesos" },
    parametros: { title: "Parámetros de Procesos", description: "Parámetros de procesos" },
    bomRutas: { title: "BOM y Rutas", description: "BOM (Bill of Materials) y rutas" },
    instrucciones: { title: "Instrucciones de Trabajo", description: "Instrucciones de trabajo (WI, SOP, ITP)" },
    control: { title: "Control de Proceso", description: "Control de procesos" },
    automaticos: { title: "Procesos Automáticos", description: "Procesos automáticos y sincronizaciones" },
  },
  activos: {
    jerarquia: { title: "Jerarquía de Activos", description: "Jerarquía de activos" },
    lineas: { title: "Líneas", description: "Gestión de líneas de producción" },
    lineAssets: { title: "Activos de Línea", description: "Activos de una línea específica" },
    estados: { title: "Estados de Disponibilidad", description: "Estados de disponibilidad" },
    especificaciones: { title: "Especificaciones Técnicas", description: "Especificaciones técnicas" },
  },
  seguridad: {
    riesgos: { title: "Riesgos", description: "Gestión de riesgos" },
    inspecciones: { title: "Inspecciones de Seguridad", description: "Inspecciones de seguridad" },
    accidentes: { title: "Accidentes", description: "Registro de accidentes" },
    capacitaciones: { title: "Capacitaciones", description: "Gestión de capacitaciones" },
    epp: { title: "EPP", description: "Equipos de protección personal" },
    saludOcupacional: { title: "Salud Ocupacional", description: "Salud ocupacional" },
  },
  configuracion: {
    empresa: { title: "Configuración de Empresa", description: "Configuración de empresa" },
    plantas: { title: "Configuración de Plantas", description: "Configuración de plantas" },
    calendario: { title: "Configuración de Calendario", description: "Configuración de calendario" },
    turnos: { title: "Configuración de Turnos", description: "Configuración de turnos" },
    zonasHorarias: { title: "Configuración de Zonas Horarias", description: "Configuración de zonas horarias" },
    unidades: { title: "Configuración de Unidades", description: "Configuración de unidades" },
    monedas: { title: "Configuración de Monedas", description: "Configuración de monedas" },
  },
  administracion: {
    seguridad: { title: "Seguridad", description: "Configuración de seguridad" },
    usuarios: { title: "Usuarios", description: "Gestión de usuarios" },
    roles: { title: "Roles", description: "Gestión de roles" },
    rolesPermisos: { title: "Roles y Permisos", description: "Permisos por rol" },
  },
  mobile: {
    scanQR: { title: "Escanear QR", description: "Escaneo de códigos QR" },
  },
  navigation: {
    dashboard: "Dashboard",
    general: "General",
    productive: "Gestión Productiva",
    people: "Gestión de Personas",
    quality: "Gestión de Calidad",
    processes: "Gestión de Procesos",
    assets: "Gestión de Activos",
    maintenance: "Gestión de Mantenimiento",
    safety: "Prevención y Seguridad",
    configuration: "Configuración General",
    system: "Sistema",
    administration: "Administración",
    mobile: "Móvil",
    orders: "Órdenes de Fabricación",
    scheduling: "Programación",
    oee: "OEE y Métricas",
    materials: "Materiales y Consumos",
    traceability: "Lotes y Trazabilidad",
    assetHierarchy: "Jerarquía de Activos",
    lines: "Líneas de Producción",
    availabilityStates: "Estados y Disponibilidad",
    technicalSpecs: "Especificaciones Técnicas",
    assetsRegistration: "Registro de Activos",
    productsRegistration: "Registro de Productos",
    shifts: "Turnos",
    laborCalendar: "Calendario Laboral",
    employees: "Empleados",
    attendance: "Asistencia",
    assignments: "Asignaciones",
    personalAssignment: "Asignación de Personal",
    specialExits: "Ausencias",
    hoursControl: "Control de Horas",
    evaluations: "Evaluaciones",
    masterData: "Datos Maestros de Procesos",
    processParameters: "Parámetros de Procesos",
    bomRoutes: "BOM y Rutas",
    workInstructions: "Instrucciones de Trabajo",
    events: "Eventos",
    energy: "Energía",
    processControl: "Control de Proceso",
    automaticProcesses: "Procesos Automáticos",
    inspectionPlans: "Planes de Inspección",
    selfControl: "Registros de Autocontrol",
    qualityCharacteristics: "Características de Calidad",
    defects: "Defectos y No Conformidades",
    statisticalControl: "Control Estadístico de Procesos",
    correctiveActions: "Acciones Correctivas",
    certificates: "Certificados y Cumplimiento",
    maintenancePlans: "Planes de Mantenimiento",
    assignmentPlans: "Planes de Asignación",
    executionPlans: "Planes de Ejecución",
    spareParts: "Almacén de Repuestos",
    kpi: "KPI y Analítica",
    risks: "Riesgos y Peligros",
    safetyInspections: "Inspecciones de Seguridad",
    accidents: "Accidentes e Incidentes",
    trainings: "Capacitaciones",
    ppe: "Equipos de Protección Personal (EPP)",
    occupationalHealth: "Salud Ocupacional",
    companyConfig: "Información de Empresa",
    plantsConfig: "Configuración de Plantas",
    calendarConfig: "Calendario de Trabajo",
    shiftsConfig: "Definición de Turnos",
    timezonesConfig: "Zonas Horarias",
    unitsConfig: "Unidades de Medida",
    currenciesConfig: "Monedas",
    externalConfig: "Recursos Externos",
    employeeManagement: "Gestión de Empleados",
    dashboards: "Dashboards Grafana",
    security: "Monitor",
    logs: "Logs",
    users: "Usuarios",
    roles: "Roles",
    rolesPermissions: "Roles y Permisos",
    scanQR: "Escanear QR",
  },
};

